<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 m-record">
                        <div class="row nav-top">
                            <div class="col-3 xtl tf-14"><span class="nav-back wt"
                                    onclick="window.location.href='#/promotion'"></span></div>
                            <div class="col-6 tfw-5 tf-18">Invite Withdraw</div>
                            <div class="col-3 xtr tf-14"><span
                                    onclick="window.location.href='#/withdrawalrecord'">Records</span></div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-3 xtc" id="xv08">
                                <div class="tf-16 mb-2 tfcdg">Bonus Balance</div>
                                <div class="tf-24 tfw-7 tffss tfcdb"><span class="tf-28" id="">{{ balance }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" id="xv09">
                            <div class="col-12 pd1628">
                                <div class="row mr-0">
                                    <div class="col-12 mt-2 mb-4 pa-0 ddavc" id="upcard">
                                        <div class="row" id="bcard" onclick="window.location.href='#/addupi'">
                                            <div class="col-12 pt-4 pb-4 tf-18 mcpl tfcdb"><span id="wpid">Add PayTm and UPI</span>
                                            </div>
                                        </div>

                                        <div class="row" id="upiadded"
                                            style="display: none; background: #dee2e6; width: 100%;margin: 0;border-radius: 6px;border: 1px solid #d0ebff;transition: .2s;"
                                            onclick="window.location.href='#/addupi'">
                                            <div class="col-12 xtl pa-0"><span class="upiTS">UPI</span></div>
                                            <div class="col-12 pt-3 xtl tfw-7 tf-20 tfcdb" id="wusr">paytm:{{ bankcard.paytm }}
                                            </div>
                                            <div class="col-12 xtl tfw-7 tf-20 tfcdb" id="wpid">upi:{{ bankcard.upi }}</div>
                                            <div class="col-12 xtr pa-0"><span class="checked"></span></div>
                                        </div>

                                    </div>



                                    <div class="col-12 pa-0" id="wdtnp">
                                        <div class="xtl tf-18 tfw-6 tfcdb">Amount</div>
                                        <div class="inpbcx rc nxb tfcb"><span class="xicon rc"></span> <input type="tel"
                                                @input="check()" class="xbox rcamt" maxlength="10" placeholder="330 ~ 50000"
                                                v-model="withdraw" autocomplete="off" id="wdamt">
                                        </div>
                                    </div>
                                </div>
                                <div class="row tfcdg tf-14 xtl tfwr">
                                    <div class="col-6 pt-2">Amount &lt; 1500,fee 30</div>
                                    <div class="col-6 pt-2 xtr">Maximum:<span id="mwa">{{ balance }}</span></div>
                                    <div class="col-6 pt-2">Amount&gt;=1500,fee 3%</div>
                                    <div class="col-6 pt-2 xtr">Minimum:330</div>
                                    <div class="col-6 pt-2 xtr">Withdraw Timings 10:00 AM to 08:00 PM</div>
                                </div>
                                <div class="mt-4 mb-2">
                                    <div class="btn-main" id="wdb" v-if="isButtonVisible" @click="withdrawal">Withdrawal</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer">
                    <div class="col-12 nav-bar adsob" id="adsob">
                        <div class="row">
                            <div class="col-3 pa-0">
                                <div class="navItem sel" id="moxht2b4u" onclick="home()">
                                    <div class="xtc"><span class="icon home sel" id="home"></span></div>
                                    <div class="xtc">Home</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="raeiyf2m0" onclick="group()">
                                    <div class="xtc"><span class="icon group" id="group"></span></div>
                                    <div class="xtc">Invite</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="sfrm6bvy" onclick="wallet()">
                                    <div class="xtc"><span class="icon wallet" id="wallet"></span></div>
                                    <div class="xtc">Recharge</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="mcpnvd2my" onclick="my()">
                                    <div class="xtc"><span class="icon my" id="my"></span></div>
                                    <div class="xtc">My</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
</section>
</template>

<script>




import axios from "axios";
export default {
    name: "WithdrawalView",
    data() {
        return {
            username: null,
            balance: 0.00,
            withdraw: null,
            password: null,
            cardselect: false,
            bankcard: [],
            result: [],
            promt: "Select Bank Card",
            startTime: '10:00',
            endTime: '20:00',
        }

    },
    mounted: function () {
        this.getUserdetails()
    },
    computed: {
    isButtonVisible() {
      const currentTime = new Date();
      const start = new Date(currentTime.toDateString() + ' ' + this.startTime);
      const end = new Date(currentTime.toDateString() + ' ' + this.endTime);

      return currentTime >= start && currentTime <= end;
    },
  },
    methods: {
        loading() {
            document.getElementById("loading").style.display = "";
            setTimeout(function () { document.getElementById("loading").style.display = "none"; }, 200);
        },
        closepopup(){
            document.getElementById("popup").style.display = "none";
        },
        check() {
            if (this.withdraw >= 230) {
                document.getElementById("wdb").className = "btn-main act";
            } else {
                document.getElementById("wdb").className = "btn-main";
            }
        },
        pop(message) {
            alert(message);
        },
        
        getUserdetails() {

            this.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/me.php?action=getuserinfo&user=' + this.username).then((res) => {
                this.Users = res.data.user_Data;
                console.log(this.Users);
                this.balance = this.Users[0].bonus;
            }).catch((err) => {
                console.log(err);
            })
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=bankcard&user=' + this.username).then((res) => {
                this.bankcard = res.data[0];
                console.log(this.bankcard);
                if (this.bankcard.upi != "") {
                    document.getElementById("bcard").style.display = "none";
                    document.getElementById("upiadded").style.display = "";

                } else {

                    document.getElementById("bcard").style.display = "";
                    document.getElementById("upiadded").style.display = "none";
                }
            }).catch((err) => {
                console.log(err);
            })

        },
        withdrawal() {

            if (this.bankcard.upi == "") {
                this.pop("Please add upi");
            } else {
                if (this.withdraw < 329) {

                    this.pop("Minimum withdraw 330");
                } else {
                    if (this.withdraw * 1 > this.balance) {

                        this.pop("Your balance is not enough");
                        console.log(this.withdraw);
                        console.log(this.withdraw < this.bankcard.balance);
                    } else {
                        axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=Invitewithdrawal&user=' + this.username + '&amount=' + this.withdraw+ '&upi=' + this.bankcard.upi).then((res) => {
                            this.result = res.data[0];
                            this.pop(this.result.status);
                            if (this.result.status == "Success") {
                                this.getUserdetails();
                                this.withdraw = null;
                                setTimeout(() => { this.$router.push("/withdrawalrecord"); }, 600);
                            }
                            console.log(this.result);
                        }).catch((err) => {
                            console.log(err);
                        })
                    }


                }

            }

        },


    }

}
</script>